// mui
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
    ErrorText: {
        width: 320,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }
}));

export default useStyles;